import { doPost, doPatch, doDelete, postFile } from 'sos-eservice-common/js/services';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { UppdateraIntygsArende, UppdateraLeveransAdress } from '../Types/ansokan.types';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { PostFilesServerResponseObject } from '../Types/Intyg.types';

const API_ROUTE = '/_api/intyg';
export class ApiService {
  private static instance: ApiService;
  public _errorCallback: (responseError: ResponseError) => void;
  private constructor() {
    this._errorCallback = this.noopCallback;
  }

  private noopCallback(responseError: ResponseError): void {}

  public static get call() {
    this.getInstance();
    const HEADERS = new Headers({ 'Content-Type': 'application/json' });
    const getValueOrDefault = <T>(response: T | ResponseError, defaultValue: T) => {
      if (response instanceof ResponseError) {
        this.getInstance()._errorCallback(response);
        return defaultValue;
      }
      return response;
    };
    return {
      async saveAnsokan(payload: UppdateraIntygsArende, ansokanId: number) {
        const response = await doPatch<string>(API_ROUTE + `/ansokan/${ansokanId}`, JSON.stringify(payload), HEADERS);
        return getValueOrDefault<string>(response, null);
      },
      async createAddress(ansokanId: number) {
        const response = await doPost<number>(API_ROUTE + `/ansokan/${ansokanId}/address`, null, HEADERS);
        return getValueOrDefault<number>(response, null);
      },
      async updateAddress(payload: UppdateraLeveransAdress, ansokanId: number, addressId: number) {
        const response = await doPatch<boolean>(
          API_ROUTE + `/ansokan/${ansokanId}/address/${addressId}`,
          JSON.stringify(payload),
          HEADERS
        );
        return getValueOrDefault<boolean>(response, null);
      },
      async deleteAddress(ansokanId: number, addressId: number) {
        const response = await doDelete<number>(
          API_ROUTE + `/ansokan/${ansokanId}/address/${addressId}`,
          null,
          HEADERS
        );
        return getValueOrDefault<number>(response, null);
      },
      async addBilaga(ansokanId: number, file: FormFieldFile, formData: FormData = new FormData()) {
        const response = await postFile<PostFilesServerResponseObject>(
          file,
          API_ROUTE + `/ansokan/${ansokanId}/bilaga`,
          new FormData()
        );
        return response;
        //return getValueOrDefault<IPostFileResponse<PostFilesServerResponseObject>>(response, null);
      },
      async deleteBilaga(ansokanId: number, filId: string) {
        const response = await doDelete<PostFilesServerResponseObject>(
          API_ROUTE + `/ansokan/${ansokanId}/bilaga/${filId}`,
          null,
          HEADERS
        );
        return response;
        //return getValueOrDefault<PostFilesServerResponseObject>(response, null);
      },
      async sendWebForm(formData: FormData) {
        const response = await doPost<string | ResponseError>('/_api/ansokanform/skicka/', formData);
        return getValueOrDefault<string | ResponseError>(response, {
          statusCode: 400,
          body: 'Okänt fel',
        } as ResponseError);
      },
    };
  }

  public setErrorCallback = (errorCallback: (responseError: ResponseError) => void) => {
    this._errorCallback = errorCallback;
  };

  public static getInstance = (): ApiService => {
    if (!ApiService.instance) ApiService.instance = new ApiService();
    return ApiService.instance;
  };
}
